async function getHighResWikipediaImage(topic, size = 1000) {
  const params = {
    action: "query",
    format: "json",
    prop: "pageimages",
    titles: topic,
    pithumbsize: size,
    origin: "*"
  };

  try {
    const response = await fetch("https://en.wikipedia.org/w/api.php?" + new URLSearchParams(params));
    if (!response.ok) throw new Error('Failed to fetch high-res image');

    const data = await response.json();
    const pages = data.query?.pages || {};
    
    for (const page of Object.values(pages)) {
      if (page.thumbnail?.source) {
        return page.thumbnail.source;
      }
    }
    return null;
  } catch (error) {
    console.error('Error fetching high-res image:', error);
    return null;
  }
}

export async function fetchRandomEvent() {
  const { getRandomDate } = await import('../utils/getRandomDate');
  const { month, day } = getRandomDate();

  const url = `https://en.wikipedia.org/api/rest_v1/feed/onthisday/events/${month}/${day}`;

  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error('Failed to fetch events');

    const data = await response.json();

    const events = data.events;
    if (!events.length) throw new Error('No events found');

    // Filter out events containing 'earthquake' or 'crash'
    const filteredEvents = events.filter(event => 
      !event.text.toLowerCase().includes('earthquake') && 
      !event.text.toLowerCase().includes('crash') &&
      !event.text.toLowerCase().includes('typhoon') &&
      !event.text.toLowerCase().includes('storm')
    );

    if (!filteredEvents.length) {
      // If all events are filtered out, try again
      return fetchRandomEvent();
    }

    const randomEvent = filteredEvents[Math.floor(Math.random() * filteredEvents.length)];
    
    // Get the first page that has an image
    const pageWithImage = randomEvent.pages.find(page => page.thumbnail);
    const wikipediaUrl = pageWithImage?.content_urls?.desktop?.page;
    
    // Extract the topic from the page title
    const topic = pageWithImage?.title?.replace(/ /g, '_');
    
    // Fetch high-resolution image
    const highResImageUrl = topic ? await getHighResWikipediaImage(topic) : null;

    return {
      text: randomEvent.text,
      year: randomEvent.year,
      pages: randomEvent.pages,
      date: `${month}/${day}`,
      imageUrl: highResImageUrl || pageWithImage?.thumbnail?.source,
      wikipediaUrl
    };
  } catch (error) {
    console.error('Error fetching event:', error);
    return null;
  }
}